'use strict';

var version = "0.0.0";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var ModalDialog = videojs.getComponent('ModalDialog');

/**
 * hot key modal.
 */

var ControlTopModal = function (_ModalDialog) {
  inherits(ControlTopModal, _ModalDialog);

  function ControlTopModal(player, options) {
    classCallCheck(this, ControlTopModal);

    var _this = possibleConstructorReturn(this, _ModalDialog.call(this, player, options));

    _this.playerClassName = 'vjs-videojs-modal-control-top_open';
    return _this;
  }

  ControlTopModal.prototype.open = function open() {
    if (!this.player().hasClass(this.playerClassName)) {
      this.player().addClass(this.playerClassName);
      _ModalDialog.prototype.open.call(this);
      this.player().trigger('control_top:opened');
      this.player().removeClass("vjs-controls-disabled");
    }
  };

  ControlTopModal.prototype.close = function close() {
    this.player().trigger('control_top:closed');
    this.player().removeClass(this.playerClassName);
    _ModalDialog.prototype.close.call(this);
  };

  return ControlTopModal;
}(ModalDialog);

var attach = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"25\" height=\"13\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 20.33403503894806 1.9999608397483826 C 20.33403503894806 1.9999608397483826 6.888384103775024 1.9999608397483826 6.888384103775024 1.9999608397483826 C 4.188819408416748 1.9999608397483826 1.9998072385787964 4.237595856189728 1.9998072385787964 6.9999611377716064 C 1.9998072385787964 9.762286305427551 4.188819408416748 11.99996143579483 6.888384103775024 11.99996143579483 C 6.888384103775024 11.99996143579483 19.11123502254486 11.99996143579483 19.11123502254486 11.99996143579483 C 19.11123502254486 11.99996143579483 19.11123502254486 10.749971389770508 19.11123502254486 10.749971389770508 C 19.11123502254486 10.749971389770508 6.888384103775024 10.749971389770508 6.888384103775024 10.749971389770508 C 4.858901381492615 10.749971389770508 3.2226072549819946 9.071725070476532 3.2226072549819946 6.9999611377716064 C 3.2226072549819946 4.928197205066681 4.858901381492615 3.249990999698639 6.888384103775024 3.249990999698639 C 6.888384103775024 3.249990999698639 20.33403503894806 3.249990999698639 20.33403503894806 3.249990999698639 C 21.67789089679718 3.249990999698639 22.77701187133789 4.379077672958374 22.77701187133789 5.749971091747284 C 22.77701187133789 7.126440346240997 21.67789089679718 8.249951183795929 20.33403503894806 8.249951183795929 C 20.33403503894806 8.249951183795929 9.334081292152405 8.249951183795929 9.334081292152405 8.249951183795929 C 8.66127896308899 8.249951183795929 8.111281275749207 7.684906423091888 8.111281275749207 6.999921023845673 C 8.111281275749207 6.314935624599457 8.66127896308899 5.74993097782135 9.334081292152405 5.74993097782135 C 9.334081292152405 5.74993097782135 19.11123502254486 5.74993097782135 19.11123502254486 5.74993097782135 C 19.11123502254486 5.74993097782135 19.11123502254486 4.499900817871094 19.11123502254486 4.499900817871094 C 19.11123502254486 4.499900817871094 9.334081292152405 4.499900817871094 9.334081292152405 4.499900817871094 C 7.987505078315735 4.499900817871094 6.888384103775024 5.623411655426025 6.888384103775024 6.999880909919739 C 6.888384103775024 8.376310050487518 7.987505078315735 9.499861001968384 9.334081292152405 9.499861001968384 C 9.334081292152405 9.499861001968384 20.33403503894806 9.499861001968384 20.33403503894806 9.499861001968384 C 22.36351776123047 9.499861001968384 23.99981188774109 7.827270746231079 23.99981188774109 5.749890863895416 C 23.99981188774109 3.6782071590423584 22.36351776123047 1.9999608397483826 20.33403503894806 1.9999608397483826 Z\"/></g></svg>";

var share = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"22\" height=\"23\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 17.831345200538635 16.137431859970093 C 17.02981173992157 16.137431859970093 16.31241500377655 16.436601519584656 15.765817761421204 16.90826106071472 C 15.765817761421204 16.90826106071472 8.238495588302612 12.743272244930267 8.238495588302612 12.743272244930267 C 8.292805552482605 12.512456715106964 8.334873914718628 12.27995640039444 8.334873914718628 12.039954781532288 C 8.334873914718628 11.799913048744202 8.29193115234375 11.568255126476288 8.238495588302612 11.336597204208374 C 8.238495588302612 11.336597204208374 15.680806636810303 7.2107595801353455 15.680806636810303 7.2107595801353455 C 16.24838948249817 7.710739552974701 16.99911057949066 8.023227035999298 17.831345200538635 8.023227035999298 C 19.585877656936646 8.023227035999298 20.99978268146515 6.680734276771545 20.99978268146515 5.011553704738617 C 20.99978268146515 3.3457828164100647 19.58500325679779 1.9999204874038696 17.831345200538635 1.9999204874038696 C 16.08021318912506 1.9999204874038696 14.665530920028687 3.3457828164100647 14.665530920028687 5.010791540145874 C 14.665530920028687 5.254122614860535 14.708473682403564 5.48245108127594 14.761909246444702 5.714109003543854 C 14.761909246444702 5.714109003543854 7.319598197937012 9.84327608346939 7.319598197937012 9.84327608346939 C 6.751043796539307 9.340768933296204 6.001294255256653 9.029083728790283 5.168185234069824 9.029083728790283 C 3.41355562210083 9.029083728790283 1.9997477531433105 10.374143779277802 1.9997477531433105 12.039954781532288 C 1.9997477531433105 13.70572566986084 3.41355562210083 15.051587998867035 5.168185234069824 15.051587998867035 C 6.000322699546814 15.051587998867035 6.751043796539307 14.739060401916504 7.318723797798157 14.239080429077148 C 7.318723797798157 14.239080429077148 14.83283281326294 18.41325533390045 14.83283281326294 18.41325533390045 C 14.781146049499512 18.625778913497925 14.748696088790894 18.84740835428238 14.748696088790894 19.06827563047409 C 14.748696088790894 20.68498718738556 16.1336487531662 21.9999617934227 17.830373644828796 21.9999617934227 C 19.528944492340088 21.9999617934227 20.914674401283264 20.685789465904236 20.914674401283264 19.06827563047409 C 20.914674401283264 17.450761795043945 19.529818892478943 16.137431859970093 17.831345200538635 16.137431859970093 Z\"/></g></svg>\n";

var survey = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"26\" height=\"26\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 13.499970078468323 9.235870838165283 C 15.49263083934784 9.235870838165283 17.113768696784973 7.612901508808136 17.113768696784973 5.617915630340576 C 17.113768696784973 3.6229297518730164 15.49263083934784 1.9999604225158691 13.499970078468323 1.9999604225158691 C 11.507212162017822 1.9999604225158691 9.886074304580688 3.6229297518730164 9.886074304580688 5.617915630340576 C 9.886074304580688 7.612901508808136 11.507212162017822 9.235870838165283 13.499970078468323 9.235870838165283 Z M 13.499970078468323 2.7332831025123596 C 15.088657975196838 2.7332831025123596 16.381215691566467 4.027318239212036 16.381215691566467 5.617915630340576 C 16.381215691566467 7.208472907543182 15.088657975196838 8.502548158168793 13.499970078468323 8.502548158168793 C 11.911185026168823 8.502548158168793 10.618627309799194 7.208472907543182 10.618627309799194 5.617915630340576 C 10.618627309799194 4.027318239212036 11.911185026168823 2.7332831025123596 13.499970078468323 2.7332831025123596 Z M 13.499970078468323 10.702516198158264 C 16.42075800895691 10.702516198158264 18.81894612312317 12.985118925571442 19.00791370868683 15.862129807472229 C 19.00791370868683 15.862129807472229 10.543623208999634 15.862129807472229 10.543623208999634 15.862129807472229 C 10.341345310211182 15.862129807472229 10.17734670639038 16.02623587846756 10.17734670639038 16.22881120443344 C 10.17734670639038 16.43134641647339 10.341345310211182 16.59545248746872 10.543623208999634 16.59545248746872 C 10.543623208999634 16.59545248746872 19.386237502098083 16.59545248746872 19.386237502098083 16.59545248746872 C 19.588515400886536 16.59545248746872 19.752514004707336 16.43134641647339 19.752514004707336 16.22881120443344 C 19.752514004707336 12.777248561382294 16.947632670402527 9.969193518161774 13.499970078468323 9.969193518161774 C 10.052210330963135 9.969193518161774 7.247426152229309 12.777248561382294 7.247426152229309 16.22881120443344 C 7.247426152229309 16.43134641647339 7.411327600479126 16.59545248746872 7.613605499267578 16.59545248746872 C 7.613605499267578 16.59545248746872 9.078614354133606 16.59545248746872 9.078614354133606 16.59545248746872 C 9.280892252922058 16.59545248746872 9.444890856742859 16.43134641647339 9.444890856742859 16.22881120443344 C 9.444890856742859 16.02623587846756 9.280892252922058 15.862129807472229 9.078614354133606 15.862129807472229 C 9.078614354133606 15.862129807472229 7.991929292678833 15.862129807472229 7.991929292678833 15.862129807472229 C 8.180994033813477 12.985118925571442 10.579182147979736 10.702516198158264 13.499970078468323 10.702516198158264 Z M 8.880708456039429 20.4656440615654 C 8.880708456039429 20.4656440615654 6.871628403663635 20.128085374832153 6.871628403663635 20.128085374832153 C 6.871628403663635 20.128085374832153 5.930093765258789 18.319468796253204 5.930093765258789 18.319468796253204 C 5.866942644119263 18.19828462600708 5.741806268692017 18.122228622436523 5.605302691459656 18.122228622436523 C 5.468701958656311 18.122228622436523 5.343565583229065 18.19828462600708 5.2805116176605225 18.319468796253204 C 5.2805116176605225 18.319468796253204 4.338976979255676 20.128085374832153 4.338976979255676 20.128085374832153 C 4.338976979255676 20.128085374832153 2.329799771308899 20.4656440615654 2.329799771308899 20.4656440615654 C 2.195142149925232 20.488308429718018 2.084287643432617 20.58398014307022 2.0421221256256104 20.71398937702179 C 1.9998594522476196 20.84391838312149 2.0334752798080444 20.986603617668152 2.129076361656189 21.08412057161331 C 2.129076361656189 21.08412057161331 3.556291699409485 22.539493918418884 3.556291699409485 22.539493918418884 C 3.556291699409485 22.539493918418884 3.256178140640259 24.556783139705658 3.256178140640259 24.556783139705658 C 3.2359697818756104 24.692007184028625 3.2926114797592163 24.827151000499725 3.4030773639678955 24.90745908021927 C 3.513446092605591 24.98784738779068 3.6594709157943726 24.9999617934227 3.781595468521118 24.9390287399292 C 3.781595468521118 24.9390287399292 5.605205535888672 24.029886722564697 5.605205535888672 24.029886722564697 C 5.605205535888672 24.029886722564697 7.428815603256226 24.9390287399292 7.428815603256226 24.9390287399292 C 7.480502367019653 24.96474176645279 7.536463975906372 24.97749799489975 7.592036962509155 24.97749799489975 C 7.668109774589539 24.97749799489975 7.7435996532440186 24.95379066467285 7.807333707809448 24.907418966293335 C 7.917799592018127 24.82711088657379 7.974441289901733 24.69196707010269 7.954330086708069 24.556743025779724 C 7.954330086708069 24.556743025779724 7.654119372367859 22.53945380449295 7.654119372367859 22.53945380449295 C 7.654119372367859 22.53945380449295 9.081431865692139 21.084080457687378 9.081431865692139 21.084080457687378 C 9.177032947540283 20.986563503742218 9.210551619529724 20.843838155269623 9.168386101722717 20.713909149169922 C 9.126317739486694 20.58398014307022 9.015366077423096 20.488308429718018 8.880708456039429 20.4656440615654 Z M 7.003759980201721 22.156044900417328 C 6.923315167427063 22.23811799287796 6.885910272598267 22.353164732456207 6.902912497520447 22.466967940330505 C 6.902912497520447 22.466967940330505 7.126370310783386 23.968953669071198 7.126370310783386 23.968953669071198 C 7.126370310783386 23.968953669071198 5.768621206283569 23.29199105501175 5.768621206283569 23.29199105501175 C 5.665830612182617 23.24068534374237 5.544871926307678 23.24068534374237 5.441984176635742 23.29199105501175 C 5.441984176635742 23.29199105501175 4.084235072135925 23.968953669071198 4.084235072135925 23.968953669071198 C 4.084235072135925 23.968953669071198 4.307692885398865 22.466967940330505 4.307692885398865 22.466967940330505 C 4.324597954750061 22.353164732456207 4.2872902154922485 22.238077878952026 4.20684540271759 22.156044900417328 C 4.20684540271759 22.156044900417328 3.1440606117248535 21.072447419166565 3.1440606117248535 21.072447419166565 C 3.1440606117248535 21.072447419166565 4.640062093734741 20.821053445339203 4.640062093734741 20.821053445339203 C 4.753345489501953 20.80199933052063 4.851181149482727 20.730837225914 4.904228091239929 20.62882751226425 C 4.904228091239929 20.62882751226425 5.605302691459656 19.282203018665314 5.605302691459656 19.282203018665314 C 5.605302691459656 19.282203018665314 6.306280136108398 20.62882751226425 6.306280136108398 20.62882751226425 C 6.3594242334365845 20.730837225914 6.457259893417358 20.80199933052063 6.57054328918457 20.821053445339203 C 6.57054328918457 20.821053445339203 8.066447615623474 21.072447419166565 8.066447615623474 21.072447419166565 C 8.066447615623474 21.072447419166565 7.003759980201721 22.156044900417328 7.003759980201721 22.156044900417328 Z M 16.775375843048096 20.4656440615654 C 16.775375843048096 20.4656440615654 14.766295790672302 20.128085374832153 14.766295790672302 20.128085374832153 C 14.766295790672302 20.128085374832153 13.824761152267456 18.319468796253204 13.824761152267456 18.319468796253204 C 13.76161003112793 18.19828462600708 13.636473655700684 18.122228622436523 13.499970078468323 18.122228622436523 C 13.363369345664978 18.122228622436523 13.238232970237732 18.19828462600708 13.17517900466919 18.319468796253204 C 13.17517900466919 18.319468796253204 12.233644366264343 20.128085374832153 12.233644366264343 20.128085374832153 C 12.233644366264343 20.128085374832153 10.224467158317566 20.4656440615654 10.224467158317566 20.4656440615654 C 10.089809536933899 20.488308429718018 9.978955030441284 20.58398014307022 9.936789512634277 20.71398937702179 C 9.894526839256287 20.84391838312149 9.928142666816711 20.986603617668152 10.023743748664856 21.08412057161331 C 10.023743748664856 21.08412057161331 11.450959086418152 22.539493918418884 11.450959086418152 22.539493918418884 C 11.450959086418152 22.539493918418884 11.150845527648926 24.556783139705658 11.150845527648926 24.556783139705658 C 11.130734324455261 24.692007184028625 11.187376022338867 24.827151000499725 11.297841906547546 24.90745908021927 C 11.408210635185242 24.98784738779068 11.55413830280304 24.9999617934227 11.676360011100769 24.9390287399292 C 11.676360011100769 24.9390287399292 13.499970078468323 24.029886722564697 13.499970078468323 24.029886722564697 C 13.499970078468323 24.029886722564697 15.323580145835876 24.9390287399292 15.323580145835876 24.9390287399292 C 15.37516975402832 24.96474176645279 15.431131362915039 24.97749799489975 15.486704349517822 24.97749799489975 C 15.562777161598206 24.97749799489975 15.63836419582367 24.95379066467285 15.702001094818115 24.907418966293335 C 15.812466979026794 24.82711088657379 15.8691086769104 24.69196707010269 15.848997473716736 24.556743025779724 C 15.848997473716736 24.556743025779724 15.54888391494751 22.53945380449295 15.54888391494751 22.53945380449295 C 15.54888391494751 22.53945380449295 16.976099252700806 21.084080457687378 16.976099252700806 21.084080457687378 C 17.071797490119934 20.986563503742218 17.105316162109375 20.843838155269623 17.063150644302368 20.713909149169922 C 17.020887970924377 20.58398014307022 16.910033464431763 20.488308429718018 16.775375843048096 20.4656440615654 Z M 14.898427367210388 22.156044900417328 C 14.81798255443573 22.23811799287796 14.780577659606934 22.353164732456207 14.79748272895813 22.466967940330505 C 14.79748272895813 22.466967940330505 15.02094054222107 23.968953669071198 15.02094054222107 23.968953669071198 C 15.02094054222107 23.968953669071198 13.663191437721252 23.29199105501175 13.663191437721252 23.29199105501175 C 13.611796140670776 23.266358256340027 13.555834531784058 23.253561913967133 13.499970078468323 23.253561913967133 C 13.444008469581604 23.253561913967133 13.388046860694885 23.266358256340027 13.33665156364441 23.29199105501175 C 13.33665156364441 23.29199105501175 11.978902459144592 23.968953669071198 11.978902459144592 23.968953669071198 C 11.978902459144592 23.968953669071198 12.202360272407532 22.466967940330505 12.202360272407532 22.466967940330505 C 12.219265341758728 22.353164732456207 12.181957602500916 22.238077878952026 12.101415634155273 22.156044900417328 C 12.101415634155273 22.156044900417328 11.03872799873352 21.072447419166565 11.03872799873352 21.072447419166565 C 11.03872799873352 21.072447419166565 12.534729480743408 20.821053445339203 12.534729480743408 20.821053445339203 C 12.64801287651062 20.80199933052063 12.745848536491394 20.730837225914 12.798895478248596 20.62882751226425 C 12.798895478248596 20.62882751226425 13.499970078468323 19.282243132591248 13.499970078468323 19.282243132591248 C 13.499970078468323 19.282243132591248 14.200947523117065 20.628867626190186 14.200947523117065 20.628867626190186 C 14.254091620445251 20.730877339839935 14.351830124855042 20.802039444446564 14.465113520622253 20.821093559265137 C 14.465113520622253 20.821093559265137 15.961115002632141 21.0724875330925 15.961115002632141 21.0724875330925 C 15.961115002632141 21.0724875330925 14.898427367210388 22.156044900417328 14.898427367210388 22.156044900417328 Z M 24.95772087574005 20.71398937702179 C 24.915555357933044 20.58398014307022 24.80470085144043 20.488308429718018 24.66994607448578 20.4656440615654 C 24.66994607448578 20.4656440615654 22.660866022109985 20.128085374832153 22.660866022109985 20.128085374832153 C 22.660866022109985 20.128085374832153 21.71933138370514 18.319468796253204 21.71933138370514 18.319468796253204 C 21.656180262565613 18.19828462600708 21.531043887138367 18.122228622436523 21.394540309906006 18.122228622436523 C 21.258036732673645 18.122228622436523 21.132803201675415 18.19828462600708 21.069749236106873 18.319468796253204 C 21.069749236106873 18.319468796253204 20.128214597702026 20.128085374832153 20.128214597702026 20.128085374832153 C 20.128214597702026 20.128085374832153 18.11903738975525 20.4656440615654 18.11903738975525 20.4656440615654 C 17.984476923942566 20.488308429718018 17.873525261878967 20.58398014307022 17.83135974407196 20.71398937702179 C 17.789194226264954 20.84391838312149 17.822712898254395 20.986603617668152 17.91831398010254 21.08412057161331 C 17.91831398010254 21.08412057161331 19.345529317855835 22.539493918418884 19.345529317855835 22.539493918418884 C 19.345529317855835 22.539493918418884 19.04541575908661 24.556783139705658 19.04541575908661 24.556783139705658 C 19.025304555892944 24.692007184028625 19.08194625377655 24.827151000499725 19.19241213798523 24.90745908021927 C 19.30268371105194 24.98784738779068 19.448708534240723 24.9999617934227 19.57083308696747 24.9390287399292 C 19.57083308696747 24.9390287399292 21.394443154335022 24.029886722564697 21.394443154335022 24.029886722564697 C 21.394443154335022 24.029886722564697 23.218053221702576 24.9390287399292 23.218053221702576 24.9390287399292 C 23.269739985466003 24.96474176645279 23.325701594352722 24.97749799489975 23.381274580955505 24.97749799489975 C 23.45734739303589 24.97749799489975 23.53283727169037 24.95379066467285 23.5965713262558 24.907418966293335 C 23.707037210464478 24.82711088657379 23.763678908348083 24.69196707010269 23.74356770515442 24.556743025779724 C 23.74356770515442 24.556743025779724 23.443454146385193 22.53945380449295 23.443454146385193 22.53945380449295 C 23.443454146385193 22.53945380449295 24.87066948413849 21.084080457687378 24.87066948413849 21.084080457687378 C 24.966367721557617 20.986603617668152 24.999886393547058 20.84391838312149 24.95772087574005 20.71398937702179 Z M 22.793094754219055 22.156044900417328 C 22.712649941444397 22.23811799287796 22.6752450466156 22.353164732456207 22.692150115966797 22.466967940330505 C 22.692150115966797 22.466967940330505 22.91570508480072 23.968953669071198 22.91570508480072 23.968953669071198 C 22.91570508480072 23.968953669071198 21.55785882472992 23.29199105501175 21.55785882472992 23.29199105501175 C 21.50636637210846 23.266358256340027 21.450501918792725 23.253561913967133 21.394540309906006 23.253561913967133 C 21.338578701019287 23.253561913967133 21.282714247703552 23.266358256340027 21.231318950653076 23.29199105501175 C 21.231318950653076 23.29199105501175 19.87356984615326 23.968953669071198 19.87356984615326 23.968953669071198 C 19.87356984615326 23.968953669071198 20.0970276594162 22.466967940330505 20.0970276594162 22.466967940330505 C 20.11402988433838 22.353164732456207 20.076624989509583 22.238077878952026 19.996180176734924 22.156044900417328 C 19.996180176734924 22.156044900417328 18.93349254131317 21.072447419166565 18.93349254131317 21.072447419166565 C 18.93349254131317 21.072447419166565 20.429396867752075 20.821053445339203 20.429396867752075 20.821053445339203 C 20.542680263519287 20.80199933052063 20.64051592350006 20.730837225914 20.693562865257263 20.62882751226425 C 20.693562865257263 20.62882751226425 21.39463746547699 19.282203018665314 21.39463746547699 19.282203018665314 C 21.39463746547699 19.282203018665314 22.095712065696716 20.62882751226425 22.095712065696716 20.62882751226425 C 22.14875900745392 20.730837225914 22.246594667434692 20.80199933052063 22.359878063201904 20.821053445339203 C 22.359878063201904 20.821053445339203 23.855782389640808 21.072447419166565 23.855782389640808 21.072447419166565 C 23.855782389640808 21.072447419166565 22.793094754219055 22.156044900417328 22.793094754219055 22.156044900417328 Z M 13.499970078468323 7.28035706281662 C 13.980015754699707 7.28035706281662 14.436744093894958 7.071483850479126 14.75298547744751 6.707289516925812 C 14.885699987411499 6.554495573043823 14.869572162628174 6.322917878627777 14.716843605041504 6.190020442008972 C 14.564212203025818 6.057123005390167 14.332884788513184 6.073329031467438 14.200170278549194 6.22616308927536 C 14.023152828216553 6.430102288722992 13.767827987670898 6.547034382820129 13.499970078468323 6.547034382820129 C 13.232015013694763 6.547034382820129 12.976690173149109 6.430102288722992 12.799672722816467 6.22616308927536 C 12.666958212852478 6.073329031467438 12.435630798339844 6.057203233242035 12.282999396324158 6.190020442008972 C 12.130270838737488 6.322917878627777 12.114143013954163 6.554495573043823 12.246857523918152 6.707289516925812 C 12.563098907470703 7.071443736553192 13.019827246665955 7.28035706281662 13.499970078468323 7.28035706281662 Z\"/></g></svg>";

var close = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"13\" height=\"13\"><defs/><g><path fill=\"rgb(0,0,0)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 11.925616264343262 1.6214458346366882 C 11.925616264343262 1.6214458346366882 11.322377324104309 1.0178917050361633 11.322377324104309 1.0178917050361633 C 11.322377324104309 1.0178917050361633 6.722352504730225 5.621004819869995 6.722352504730225 5.621004819869995 C 6.722352504730225 5.621004819869995 2.122424840927124 1.0178917050361633 2.122424840927124 1.0178917050361633 C 2.122424840927124 1.0178917050361633 1.5191859006881714 1.6214458346366882 1.5191859006881714 1.6214458346366882 C 1.5191859006881714 1.6214458346366882 6.119113564491272 6.224518835544586 6.119113564491272 6.224518835544586 C 6.119113564491272 6.224518835544586 1.5191859006881714 10.82723081111908 1.5191859006881714 10.82723081111908 C 1.5191859006881714 10.82723081111908 2.122424840927124 11.430784940719604 2.122424840927124 11.430784940719604 C 2.122424840927124 11.430784940719604 6.722352504730225 6.828032851219177 6.722352504730225 6.828032851219177 C 6.722352504730225 6.828032851219177 11.322377324104309 11.430784940719604 11.322377324104309 11.430784940719604 C 11.322377324104309 11.430784940719604 11.925616264343262 10.82723081111908 11.925616264343262 10.82723081111908 C 11.925616264343262 10.82723081111908 7.325299978256226 6.224518835544586 7.325299978256226 6.224518835544586 C 7.325299978256226 6.224518835544586 11.925616264343262 1.6214458346366882 11.925616264343262 1.6214458346366882 Z\"/></g></svg>";

var comment = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"22\" height=\"20\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 1.999725103378296 3.8213735818862915 C 1.999725103378296 3.8213735818862915 1.999725103378296 13.839264988899231 1.999725103378296 13.839264988899231 C 1.999725103378296 14.826428592205048 2.8699475526809692 15.66063779592514 3.8997966051101685 15.66063779592514 C 3.8997966051101685 15.66063779592514 6.433128118515015 15.66063779592514 6.433128118515015 15.66063779592514 C 6.433128118515015 15.66063779592514 6.433128118515015 18.696419596672058 6.433128118515015 18.696419596672058 C 6.433128118515015 18.8217756152153 6.513475775718689 18.934375405311584 6.635406017303467 18.979623913764954 C 6.672810912132263 18.99358355998993 6.71147882938385 18.99996167421341 6.7497581243515015 18.99996167421341 C 6.8371981382369995 18.99996167421341 6.92269504070282 18.96538347005844 6.984097361564636 18.90067970752716 C 6.984097361564636 18.90067970752716 10.056350827217102 15.66063779592514 10.056350827217102 15.66063779592514 C 10.056350827217102 15.66063779592514 19.099785685539246 15.66063779592514 19.099785685539246 15.66063779592514 C 20.12953758239746 15.66063779592514 20.999760031700134 14.826428592205048 20.999760031700134 13.839264988899231 C 20.999760031700134 13.839264988899231 20.999760031700134 3.8213735818862915 20.999760031700134 3.8213735818862915 C 20.999760031700134 2.834169864654541 20.12953758239746 1.9999606609344482 19.099785685539246 1.9999606609344482 C 19.099785685539246 1.9999606609344482 3.8997966051101685 1.9999606609344482 3.8997966051101685 1.9999606609344482 C 2.8699475526809692 1.9999606609344482 1.999725103378296 2.834169864654541 1.999725103378296 3.8213735818862915 Z M 14.666382670402527 8.678528189659119 C 14.666382670402527 8.008866310119629 15.234548449516296 7.464239537715912 15.933097004890442 7.464239537715912 C 16.631645560264587 7.464239537715912 17.199714183807373 8.008866310119629 17.199714183807373 8.678528189659119 C 17.199714183807373 9.348190069198608 16.631645560264587 9.892816841602325 15.933097004890442 9.892816841602325 C 15.234548449516296 9.892816841602325 14.666382670402527 9.348190069198608 14.666382670402527 8.678528189659119 Z M 10.233076810836792 8.678528189659119 C 10.233076810836792 8.008866310119629 10.801145434379578 7.464239537715912 11.499791145324707 7.464239537715912 C 12.198339700698853 7.464239537715912 12.766408324241638 8.008866310119629 12.766408324241638 8.678528189659119 C 12.766408324241638 9.348190069198608 12.198339700698853 9.892816841602325 11.499791145324707 9.892816841602325 C 10.801145434379578 9.892816841602325 10.233076810836792 9.348190069198608 10.233076810836792 8.678528189659119 Z M 5.799770951271057 8.678528189659119 C 5.799770951271057 8.008866310119629 6.367839574813843 7.464239537715912 7.066388130187988 7.464239537715912 C 7.765033841133118 7.464239537715912 8.333102464675903 8.008866310119629 8.333102464675903 8.678528189659119 C 8.333102464675903 9.348190069198608 7.765033841133118 9.892816841602325 7.066388130187988 9.892816841602325 C 6.367839574813843 9.892816841602325 5.799770951271057 9.348190069198608 5.799770951271057 8.678528189659119 Z\"/></g></svg>";

var info = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"23\" height=\"23\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 18.235295057296753 4.910185754299164 C 14.72214961051941 1.363914132118225 9.026112794876099 1.3634728789329529 5.512967348098755 4.910185754299164 C 1.9998219013214111 8.456898629665375 2.0002105236053467 14.207350254058838 5.512967348098755 17.754103243350983 C 9.026112794876099 21.30037486553192 14.72214961051941 21.30077600479126 18.235295057296753 17.754103243350983 C 21.748440504074097 14.207350254058838 21.74805188179016 8.457299768924713 18.235295057296753 4.910185754299164 Z M 13.047284722328186 15.280999481678009 C 13.047284722328186 15.935297727584839 12.522061705589294 16.46564394235611 11.873936891555786 16.46564394235611 C 11.225812077522278 16.46564394235611 10.700589060783386 15.935297727584839 10.700589060783386 15.280999481678009 C 10.700589060783386 15.280999481678009 10.700589060783386 10.542622208595276 10.700589060783386 10.542622208595276 C 10.700589060783386 9.888323962688446 11.225812077522278 9.357977747917175 11.873936891555786 9.357977747917175 C 12.522061705589294 9.357977747917175 13.047284722328186 9.888323962688446 13.047284722328186 10.542622208595276 C 13.047284722328186 10.542622208595276 13.047284722328186 15.280999481678009 13.047284722328186 15.280999481678009 Z M 11.853242754936218 8.517711341381073 C 11.177331447601318 8.517711341381073 10.726723909378052 8.034418761730194 10.740811467170715 7.437764227390289 C 10.726723909378052 6.812267780303955 11.177331447601318 6.343576669692993 11.866941690444946 6.343576669692993 C 12.556843400001526 6.343576669692993 12.993363380432129 6.8126689195632935 13.007450938224792 7.437764227390289 C 13.007450938224792 8.034418761730194 12.557232022285461 8.517711341381073 11.853242754936218 8.517711341381073 Z\"/></g></svg>";

var playlist = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"22\" height=\"21\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 1.9999184608459473 7.142806768417358 C 1.9999184608459473 7.142806768417358 17.199907541275024 7.142806768417358 17.199907541275024 7.142806768417358 C 17.199907541275024 7.142806768417358 17.199907541275024 9.714269876480103 17.199907541275024 9.714269876480103 C 17.199907541275024 9.714269876480103 1.9999184608459473 9.714269876480103 1.9999184608459473 9.714269876480103 C 1.9999184608459473 9.714269876480103 1.9999184608459473 7.142806768417358 1.9999184608459473 7.142806768417358 Z M 1.9999184608459473 1.9999607801437378 C 1.9999184608459473 1.9999607801437378 17.199907541275024 1.9999607801437378 17.199907541275024 1.9999607801437378 C 17.199907541275024 1.9999607801437378 17.199907541275024 4.571423888206482 17.199907541275024 4.571423888206482 C 17.199907541275024 4.571423888206482 1.9999184608459473 4.571423888206482 1.9999184608459473 4.571423888206482 C 1.9999184608459473 4.571423888206482 1.9999184608459473 1.9999607801437378 1.9999184608459473 1.9999607801437378 Z M 1.9999184608459473 12.285692870616913 C 1.9999184608459473 12.285692870616913 12.133244514465332 12.285692870616913 12.133244514465332 12.285692870616913 C 12.133244514465332 12.285692870616913 12.133244514465332 14.857155978679657 12.133244514465332 14.857155978679657 C 12.133244514465332 14.857155978679657 1.9999184608459473 14.857155978679657 1.9999184608459473 14.857155978679657 C 1.9999184608459473 14.857155978679657 1.9999184608459473 12.285692870616913 1.9999184608459473 12.285692870616913 Z M 14.666478872299194 12.285692870616913 C 14.666478872299194 12.285692870616913 14.666478872299194 19.999961853027344 14.666478872299194 19.999961853027344 C 14.666478872299194 19.999961853027344 20.9998562335968 16.14280730485916 20.9998562335968 16.14280730485916 C 20.9998562335968 16.14280730485916 14.666478872299194 12.285692870616913 14.666478872299194 12.285692870616913 Z\"/></g></svg>";

var search = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"20\" height=\"20\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 17.912848114967346 17.399656772613525 C 17.912848114967346 17.399656772613525 13.821141242980957 13.295320212841034 13.821141242980957 13.295320212841034 C 14.918707728385925 12.029605507850647 15.58325183391571 10.378155291080475 15.58325183391571 8.573189079761505 C 15.58325183391571 4.599944829940796 12.361378788948059 1.3718969821929932 8.404038071632385 1.3718969821929932 C 4.443005442619324 1.3718969821929932 1.22482430934906 4.603635311126709 1.22482430934906 8.573189079761505 C 1.22482430934906 12.542662620544434 4.446697354316711 15.774441063404083 8.404038071632385 15.774441063404083 C 10.203553557395935 15.774441063404083 11.84995186328888 15.107867956161499 13.1118084192276 14.006901144981384 C 13.1118084192276 14.006901144981384 17.20351529121399 18.111157476902008 17.20351529121399 18.111157476902008 C 17.300573706626892 18.208513975143433 17.43124794960022 18.26094287633896 17.55823028087616 18.26094287633896 C 17.685115456581116 18.26094287633896 17.815789699554443 18.212284684181213 17.912848114967346 18.111157476902008 C 18.106964945793152 17.916484594345093 18.106964945793152 17.594369769096375 17.912848114967346 17.399656772613525 Z M 2.229121446609497 8.573189079761505 C 2.229121446609497 5.157889425754547 4.999221086502075 2.382968485355377 8.400346159934998 2.382968485355377 C 11.805163145065308 2.382968485355377 14.571570873260498 5.161660134792328 14.571570873260498 8.573189079761505 C 14.571570873260498 11.984677910804749 11.805163145065308 14.767060041427612 8.400346159934998 14.767060041427612 C 4.999221086502075 14.767060041427612 2.229121446609497 11.988408505916595 2.229121446609497 8.573189079761505 Z\"/></g></svg>";

var Button = videojs.getComponent('Button');
var icons$1 = {
  attach: attach,
  share: share,
  survey: survey,
  close: close,
  comment: comment,
  info: info,
  playlist: playlist,
  search: search
};
/**
 * send mail button.
 */
var dom$1 = videojs.dom || videojs;

var ControlTopButton = function (_Button) {
  inherits(ControlTopButton, _Button);

  function ControlTopButton(player, options) {
    classCallCheck(this, ControlTopButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-control-top-button');
    _this.addClass('vjs-icon-button');
    _this.addClass(options.id);
    _this.options = options;
    _this.controlText(options.placeholder);
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div>' + icons$1[options.icon] + '</div>';
    dom$1.appendContent(_this.el(), wrapper.firstChild);
    return _this;
  }

  ControlTopButton.prototype.handleClick = function handleClick() {
    this.player().getChild('ControlTopOverlay').open(this.options);
  };

  return ControlTopButton;
}(Button);

var Component$1 = videojs.getComponent('Component');
var dom$2 = videojs.dom || videojs;

var ModalContent = function (_Component) {
  inherits(ModalContent, _Component);

  function ModalContent(player, options) {
    classCallCheck(this, ModalContent);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.lastChild = [];
    _this.history = [];
    return _this;
  }

  ModalContent.prototype.createEl = function createEl() {
    return dom$2.createEl('div', {

      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      className: 'vjs-modal-content'
    });
  };

  ModalContent.prototype.getContent = function getContent(options) {
    this._createContent(options);
    return this.innerHTML;
  };

  ModalContent.prototype._createContent = function _createContent(options) {
    var options_plugin = [];
    if (this.lastChild.length > 0) {
      for (var i = 0; i < this.lastChild.length; i++) {
        this.removeClass(this.lastChild[i] + '-navigation-show');
      }
      this.lastChild = [];
    }
    if (this.history.indexOf(options.nav) === -1) {
      addingHistory(this.history, options.nav);
      showContent(this, this.lastChild, options.nav);
      if (options.children) {
        for (var i = 0; i < options.children.length; i++) {
          if (options.children[i].type === "plugin") {
            if (this.player[options.children[i].child]) {
              options_plugin = _typeof(options.children[i].options) !== undefined && options.children[i].options !== "" ? options.children[i].options : [];
              var child = this.addChild(options.children[i].child, options_plugin);
            }
          } else if (options.children[i].type === "component") {
            if (this.player[options.nav]) {
              options_plugin = _typeof(options.children[i].options) !== undefined && options.children[i].options !== "" ? options.children[i].options : [];
              this.addChild(options.children[i].child, options_plugin);
            }
          }
        }
      } else if (options && options.nav && this.player[options.nav]) {
        if (!this.getChild(options.nav)) {
          options_plugin = _typeof(options.options) !== undefined ? options.options : [];
          this.addChild(options.nav, options_plugin);
        }
      }
    } else {
      showContent(this, this.lastChild, options.nav);
    }

    function addingHistory(history, nav) {
      history.push(nav);
    }
    function showContent(parent, lastChild, nav) {
      lastChild.push(nav);
      parent.addClass(nav + '-navigation-show');
    }
  };

  return ModalContent;
}(Component$1);

var Component = videojs.getComponent('Component');

/**
 * hot key overlay.
 */

var ControlTopOverlay = function (_Component) {
  inherits(ControlTopOverlay, _Component);

  function ControlTopOverlay(player, options) {
    classCallCheck(this, ControlTopOverlay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass("vjs-control-top-overlay");
    _this.player = player;
    _this.options = options;
    return _this;
  }

  ControlTopOverlay.prototype._createModal = function _createModal(options) {
    var content = new ModalContent(this.player, this.options).getContent(options);

    this.modal = new ControlTopModal(this.player, {
      content: content
      //pauseOnOpen: false,
      //temporary: true
    });

    this.el = this.modal.contentEl();

    this.player.addChild(this.modal);
  };

  ControlTopOverlay.prototype.open = function open(options) {
    this._createModal(options);
    this.modal.open();
  };

  return ControlTopOverlay;
}(Component);

var chapters = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"chapter_fix_icon\" x=\"0px\" y=\"0px\" viewBox=\"0 0 60.123 60.123\" style=\"enable-background:new 0 0 60.123 60.123;\" xml:space=\"preserve\" width=\"20px\" height=\"20px\">\n<g>\n\t<path d=\"M57.124,51.893H16.92c-1.657,0-3-1.343-3-3s1.343-3,3-3h40.203c1.657,0,3,1.343,3,3S58.781,51.893,57.124,51.893z\" fill=\"#FFFFFF\"/>\n\t<path d=\"M57.124,33.062H16.92c-1.657,0-3-1.343-3-3s1.343-3,3-3h40.203c1.657,0,3,1.343,3,3   C60.124,31.719,58.781,33.062,57.124,33.062z\" fill=\"#FFFFFF\"/>\n\t<path d=\"M57.124,14.231H16.92c-1.657,0-3-1.343-3-3s1.343-3,3-3h40.203c1.657,0,3,1.343,3,3S58.781,14.231,57.124,14.231z\" fill=\"#FFFFFF\"/>\n\t<circle cx=\"4.029\" cy=\"11.463\" r=\"4.029\" fill=\"#FFFFFF\"/>\n\t<circle cx=\"4.029\" cy=\"30.062\" r=\"4.029\" fill=\"#FFFFFF\"/>\n\t<circle cx=\"4.029\" cy=\"48.661\" r=\"4.029\" fill=\"#FFFFFF\"/>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

// import Routing from '../../../src/core/router/router';

function cookiesUserId() {
  var user_id;
  if (getCookieStats('uepUserID') == '') {
    user_id = guid();
    createCookie('uepUserID', user_id, 10 * 365);
    return user_id;
  } else {
    user_id = getCookieStats('uepUserID');
    return user_id;
  }
}

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function getCookieStats(c_name) {
  var c_start;
  var c_end;
  if (document.cookie.length > 0) {
    c_start = document.cookie.indexOf(c_name + '=');
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      c_end = document.cookie.indexOf(';', c_start);
      if (c_end == -1) {
        c_end = document.cookie.length;
      }
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return '';
}

function createCookie(name, value, days) {
  var expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toGMTString();
  } else {
    expires = '';
  }
  document.cookie = name + '=' + value + expires + '; path=/';
}
function formatAnswer(answer, type) {
  var responses;
  var response = { response: '' };
  if (type === 'quiz') {
    responses = [];
    for (var i = 0; i < answer.length; i++) {
      response.response = answer[i].value;
      responses.push(response);
    }
  } else {
    responses = answer[0].value;
  }
  return responses;
}

function sendData(answer, marker, setting) {
  if (!setting.isTmp) {
    var HTTP = interactivityPlayer.optionsInteractivity.api.HTTP;
    var URL = interactivityPlayer.optionsInteractivity.api.URL;
    var client = interactivityPlayer.optionsInteractivity.api.client;

    var params = {
      votes: [{
        id_inter: marker.id,
        id_user: cookiesUserId(),
        type: marker.type,
        responses: formatAnswer(answer, marker.type)
      }],
      client: client
    };

    HTTP.post(URL, params, {
      emulateJSON: true
    }).then(function (response) {
      if (response.data.code === 200) {
        console.log(response);
      }
    }, function (response) {
      console.log('api error');
      eventHub.$emit('error', { code: response.code, cause: response.message });
    });
  }
}

function downloadFile(_ref) {
  var id = _ref.id,
      name = _ref.name,
      type = _ref.type;

  if (!id) {
    return;
  }
  var HTTP = interactivityPlayer.optionsInteractivity.apiFileDownload.HTTP;
  var URL = interactivityPlayer.optionsInteractivity.apiFileDownload.URL;

  HTTP.get(URL + ('/' + id + '?type=' + type), {
    responseType: 'blob'
  }).then(function (response) {
    var link = document.createElement('a');
    var contentBlob = new Blob([response.data], { type: 'octet/stream' });
    link.href = window.URL.createObjectURL(contentBlob);
    link.target = '_blank';
    link.download = name;
    link.click();
  }, function (response) {
    console.error('api error', response);
  });
}

var icons = {
  attach: attach,
  share: share,
  survey: survey,
  close: close,
  comment: comment,
  info: info,
  playlist: playlist,
  search: search,
  chapters: chapters
};

window.cancel = cancel;
window.submit = submit;
window.openModal = openModal;
window.handleAnswer = handleAnswer;
var dom = videojs.dom || videojs;

// Default options for the plugin.
var defaults = {
  markerStyle: {
    display: 'flex',
    'border-radius': '30%',
    height: 'inherit',
    'z-index': '1000',
    position: 'absolute'
  },
  markerTip: {
    display: false,
    text: function text(marker) {
      return '';
    },
    time: function time(marker) {
      return marker.start;
    }
  },
  breakOverlay: {
    display: true,
    displayTime: 0.01,
    text: function text(marker) {
      if (options.currentSkin.indexOf('skin-i2') > -1 || options.currentSkin.indexOf('skin-dark') > -1) {
        if (marker.type === 'question') return questionContentI2(marker);else if (marker.type === 'quiz' || marker.type === 'sondage') return quizContentI2(marker);else if (marker.type === 'chapter') return chapterContentI2(marker);else if (marker.type === 'hidden-area') return hiddenAreaContentI2(marker);
      } else {
        if (marker.type === 'question') return questionContent(marker);else if (marker.type === 'quiz' || marker.type === 'sondage') return quizContent(marker);else if (marker.type === 'chapter') return chapterContent(marker);
      }
    },
    style: {}
  },
  onMarkerClick: function onMarkerClick(marker) {
    player.pause();
    setContentPosition(marker);
  },
  onMarkerReached: function onMarkerReached(marker, index) {
    // player.pause();
    setContentPosition(marker);
    player.bigPlayButton.hide();
  },
  markers: []
};

var isOverlayInfoVisible = false;

function cancel() {
  player.play();
}

function formatResponse(answer) {
  var responses = [];
  for (var i = 0; i < answer.length; i++) {
    responses.push(answer[i].value);
  }
  return responses;
}

function submit(order) {
  var marker = setting.markers[parseInt(order)];
  var answer;
  if (marker.type !== 'chapter') {
    if (marker.type === 'question') {
      answer = docShadow.querySelectorAll('input[name="resp"]:checked');
      sendData(answer, marker, setting);
    } else if (marker.type === 'quiz' || marker.type === 'sondage') {
      answer = docShadow.querySelectorAll('input[name="' + marker.id + '"]:checked');
      sendData(answer, marker, setting);
    }
    setting.markers[parseInt(order)].answered = formatResponse(answer);
  }
  // Service.sendData(answer,marker.type);
  if (marker.type === 'quiz') {

    if (answer.length == 1 && marker.nsp === false) {
      var redirect = marker.choices.filter(function (choice) {
        return choice.id == answer[0].value;
      });
      if (redirect && redirect[0] && redirect[0].redirect) {
        console.log(redirect[0].redirect);
        handleRedirectChoices(redirect[0]);
      }
    }
    player.play();
    player.bigPlayButton.show();
  } else {
    player.play();
    player.bigPlayButton.show();
  }
}

function handleAnswer(order) {
  var marker = setting.markers[parseInt(order)];
  if (marker.redirect) {
    handleRedirect(marker);
  }
}

function handleRedirect(question) {
  if (question.redirect.type === 'web') {
    handleRedirectWeb(question.redirect);
  } else if (question.redirect.type === 'video') {
    handleRedirectVideo(question.redirect);
  }
  if (question.redirect.type === 'download') {
    var type = question.type === 'question' ? 'survey' : 'quiz';
    handleRedirectFiles(question.redirect, type);
  }
}
function handleRedirectChoices(question) {
  if (question.redirect.type === 'web') {
    console.log(question.redirect);
    window.open(question.redirect.link, '_blank');
    player.currentTime(player.currentTime() + 1);
    player.bigPlayButton.show();
    //return false;
  }
  if (question.redirect.type === 'timeCode') {
    console.log(question.redirect);
    // player.currentTime();
    var hms = question.redirect.timeCode; // your input string
    var a = hms.split(':'); // split it at the colons
    var seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
    player.currentTime(seconds);
    player.play();
    player.bigPlayButton.show();

    //return true
  }
}

function handleRedirectWeb(redirect) {
  if (docShadow.querySelector('.link-file-wrapper')) {
    return;
  }
  var wrapper = docShadow.querySelector('.vjs-survey-entry__redirect');
  var a = document.createElement('a');
  var linkText = document.createTextNode(redirect.link);
  a.appendChild(linkText);
  a.href = redirect.link;
  a.className = 'link-file-wrapper';
  a.target = '_blank';
  wrapper.appendChild(a);
}

function handleRedirectVideo(redirect) {
  if (docShadow.querySelector('.link-thumbnail-wrapper')) {
    return;
  }
  var wrapper = docShadow.querySelector('.vjs-survey-entry__redirect');

  var a = document.createElement('a');
  a.href = redirect.video_url;
  a.className = 'link-thumbnail-wrapper';
  a.target = '_blank';
  wrapper.appendChild(a);

  var titleEl = document.createElement('div');
  titleEl.className = 'video-title-wrapper';
  titleEl.innerText = redirect.video_title;
  a.appendChild(titleEl);

  var videoEl = document.createElement('div');
  videoEl.className = 'video-thumbnail-wrapper';
  videoEl.style.backgroundImage = 'url(' + redirect.video_logo + ')';
  a.appendChild(videoEl);
}

function handleRedirectFiles(redirect, type) {
  if (docShadow.querySelector('.file-wrapper')) {
    return;
  }
  var wrapper = docShadow.querySelector('.vjs-survey-entry__redirect');

  redirect.files.forEach(function (file) {
    var fileWrapper = document.createElement('div');
    fileWrapper.className = 'file-wrapper';
    fileWrapper.innerHTML = '<span class="icon-file mr-2"></span>';

    var fileName = document.createElement('div');
    fileName.className = 'file-wrapper__name';
    fileName.innerText = file.title;

    fileWrapper.appendChild(fileName);
    wrapper.appendChild(fileWrapper);

    fileWrapper.addEventListener('click', function () {
      downloadFile({ id: file.id, name: file.title, type: type });
    });
  });
}

var svg_indicator = '\n  <svg class="marker-indicator" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="3em" height="inherit" viewBox="0 0 481.013 494.304" enable-background="new 0 0 481.013 494.304" xml:space="preserve">\n  <path fill="white" d="M244.585,178.458V24.996h-8.162v153.461H171.81V315.85h64.613v153.457h8.162V315.85h64.617V178.458H244.585z\n     M301.041,307.688H179.972V186.619h121.069V307.688z"></path>\n  </svg>';
var svg_survey = '<div class="marker-info"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="inherit" viewBox="0 0 481.013 494.304" enable-background="new 0 0 481.013 494.304" xml:space="preserve">\n  <g id="Forma_1">\n    <g>\n      <path fill="white" fill-rule="evenodd" clip-rule="evenodd" d="M241.499,90.101c-79.756,0-144.409,63.115-144.409,140.979\n        c0,53.264,30.251,99.566,74.864,123.555l-1.699,58.263l68.139-40.994c1.036,0.021,2.057,0.152,3.106,0.152\n        c79.764,0,144.41-63.108,144.41-140.977C385.909,153.216,321.263,90.101,241.499,90.101z M235.03,315.867\n        c-12.889,0-21.673-9.275-21.673-21.634c0-12.62,8.998-21.65,21.673-21.65c13.171,0,21.699,9.03,21.929,21.65\n        C256.967,306.571,248.201,315.867,235.03,315.867z M264.491,227.391c-9.002,9.758-12.656,19.021-12.409,29.749v4.251h-32.407\n        l-0.243-6.17c-0.726-12.114,3.407-24.499,14.394-37.324c7.778-9.06,14.126-16.66,14.126-24.744\n        c0-8.316-5.623-13.783-17.807-14.247c-8.004,0-17.783,2.83-24.077,7.127l-8.297-25.949c8.772-4.984,23.36-9.71,40.666-9.71\n        c32.17,0,46.769,17.341,46.769,37.089C285.206,205.511,273.776,217.4,264.491,227.391z"></path>\n    </g>\n  </g>\n  </svg><span>Question</span></div>\n';
var svg_like = '<div class="marker-info"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t width="30px" height="inherit" viewBox="0 0 481.013 494.304" enable-background="new 0 0 481.013 494.304"\n\t xml:space="preserve">\n  <g id="Shape_1">\n    <g>\n      <path fill-rule="evenodd" fill="white" clip-rule="evenodd" d="M134.599,198.523H93.533c-5.645,0-10.268,4.511-10.268,10.074v181.313\n        c0,5.559,4.603,10.07,10.268,10.07h41.066c5.665,0,10.267-4.513,10.267-10.07V208.596\n        C144.866,203.034,140.245,198.523,134.599,198.523z M372.101,198.523c-1.654-0.275-79.07,0-79.07,0l10.812-28.943\n        c7.461-19.992,2.632-50.515-18.072-61.367c-6.742-3.533-16.158-5.309-23.751-3.434c-4.354,1.076-8.183,3.904-10.462,7.694\n        c-2.624,4.359-2.353,9.446-3.288,14.279c-2.369,12.26-8.272,23.914-17.416,32.662c-15.938,15.254-65.454,59.255-65.454,59.255\n        v161.168h171.112c23.089,0.013,38.219-25.284,26.832-45.044c13.572-8.531,18.216-26.497,10.267-40.293\n        c13.575-8.53,18.217-26.496,10.266-40.291C407.299,239.49,399.468,203.064,372.101,198.523z"/>\n    </g>\n  </g>\n  </svg><span>Quiz</span></div>\n';
var svg_sondage = '<div class="marker-info"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t width="30px" height="inherit" viewBox="0 0 481.013 494.304" enable-background="new 0 0 481.013 494.304"\n\t xml:space="preserve">\n  <g id="Shape_1">\n    <g>\n      <path fill-rule="evenodd" fill="white" clip-rule="evenodd" d="M134.599,198.523H93.533c-5.645,0-10.268,4.511-10.268,10.074v181.313\n        c0,5.559,4.603,10.07,10.268,10.07h41.066c5.665,0,10.267-4.513,10.267-10.07V208.596\n        C144.866,203.034,140.245,198.523,134.599,198.523z M372.101,198.523c-1.654-0.275-79.07,0-79.07,0l10.812-28.943\n        c7.461-19.992,2.632-50.515-18.072-61.367c-6.742-3.533-16.158-5.309-23.751-3.434c-4.354,1.076-8.183,3.904-10.462,7.694\n        c-2.624,4.359-2.353,9.446-3.288,14.279c-2.369,12.26-8.272,23.914-17.416,32.662c-15.938,15.254-65.454,59.255-65.454,59.255\n        v161.168h171.112c23.089,0.013,38.219-25.284,26.832-45.044c13.572-8.531,18.216-26.497,10.267-40.293\n        c13.575-8.53,18.217-26.496,10.266-40.291C407.299,239.49,399.468,203.064,372.101,198.523z"/>\n    </g>\n  </g>\n  </svg><span>Sondage</span></div>\n';
var svg_comment = '<div class="marker-info"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t width="30px" height="inherit" viewBox="0 0 481.013 494.304" enable-background="new 0 0 481.013 494.304"\n     xml:space="preserve">\n  <g id="Forma_1_1_">\n    <g>\n      <path   fill-rule="evenodd" fill="white" clip-rule="evenodd" d="M362.899,99.627H119.101c-16.762,0-30.473,13.714-30.473,30.475V312.95\n        c0,16.761,13.711,30.475,30.473,30.475h213.322l60.949,60.948V130.102C393.372,113.341,379.657,99.627,362.899,99.627z\n         M332.423,282.475H149.577V252h182.847V282.475z M332.423,236.762H149.577v-30.473h182.847V236.762z M332.423,191.052H149.577\n        v-30.475h182.847V191.052z"/>\n    </g>\n  </g>\n  </svg><span>Commentaire</span></div>';

var svg_chapters = '<div class="marker-info">' + icons.chapters + '<span> Chapitre</span></div>';
var NULL_INDEX = -1;
var setting = {};
var options = {};
var markersMap = {};
var markersList = [];
var currentMarkerIndex = NULL_INDEX;
var player = void 0;
var markerTip = null;
var breakOverlay = null;
var overlayIndex = NULL_INDEX;

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = dom || videojs;
var controlTopOptions = [];
/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */

// setup the plugin after we loaded video's meta data

var onPlayerReady = function onPlayerReady(player, opt) {
  player.addClass('vjs-skin-control-bar');
  options = opt;
  setting = options;
  controlTopOptions = [{
    nav: 'info',
    placeholder: 'Info',
    id: 'info-navigation-button',
    icon: 'info',
    options: setting.infoOptions
  }];

  window.interactivityPlayer = player;
  videojs.getComponent('Player').prototype.optionsInteractivity = setting;
  player.one('durationchange', function (e) {
    initialize();
    _initOverlayInfo();
  });
};

function _initOverlayInfo() {
  var overlayInfoButtonEl = dom.createEl('button', {
    className: 'info-overlay-button',
    innerHTML: "<span class='icon info'></span>"
  });
  player.el().appendChild(overlayInfoButtonEl);

  overlayInfoButtonEl.addEventListener('click', function (e) {
    _toggleOverlayInfo(this);
  });
}

function _toggleOverlayInfo(button) {
  isOverlayInfoVisible = !isOverlayInfoVisible;
  var VideoInfoEl = docShadow.querySelector('.vjs-info');

  if (isOverlayInfoVisible) {
    VideoInfoEl.classList.add('toggle-overlay-info');
    button.innerHTML = "<span class='icon close'></span>";
  } else {
    VideoInfoEl.classList.remove('toggle-overlay-info');
    button.innerHTML = "<span class='icon info'></span>";
  }
}

function setContentPosition(marker) {
  var overlay = docShadow.querySelector('.vjs-break-overlay');
  if (markerTip === null) {
    initializeMarkerTip();
  }
  if (!overlay.querySelector('.vjs-tip')) {
    overlay.appendChild(markerTip);
  }
  overlay.style.visibility = 'visible';
  var parentWidth = overlay.parentElement.offsetWidth;
  var markerPosition = parentWidth * (getPosition(marker) / 100);
  var widthOverlay = overlay.offsetWidth;
  var left = markerPosition - widthOverlay / 2;
  var right = parentWidth - (left + widthOverlay);
  if (left > 0) {
    if (right > 0) {
      overlay.style.left = left + 'px';
      markerTip.style.right = 'unset';
      markerTip.style.left = '50%';
      markerTip.style.transform = 'translateX(-5px)';
    } else {
      overlay.style.left = 'unset';
      overlay.style.right = '0px';
      markerTip.style.right = parentWidth - markerPosition + 'px';
      markerTip.style.left = 'unset';
      markerTip.style.transform = 'translateX(5px)';
    }
  } else {
    overlay.style.left = '0px';
    try {
      overlay.style.right = 'unset';
    } catch (e) {
      overlay.style.right = '0px';
    }

    markerTip.style.left = markerPosition + 'px';
    markerTip.style.transform = 'translateX(-5px)';
    try {
      markerTip.style.right = 'unset';
    } catch (e) {
      markerTip.style.right = '0px';
    }
  }
}

function setCheckedValue(marker, value) {
  return marker.answered.indexOf(value) > -1 ? 'checked' : '';
}

function questionContent(marker) {
  var nsp = '';
  if (marker.nsp) {
    nsp = '<div class="vjs-survey-entry__choice">\n    <input onchange="handleAnswer(' + marker.order + ')" type="radio" id="choice_3" value="2" ' + setCheckedValue(marker, '2') + ' name="resp"/>\n    <label for="choice_3"></label>\n        <span>' + player.localize('Nsp') + '</span>\n    </div>';
  }
  var content = '<h1 class="vjs-survey-entry__question">' + marker.title + '</h1>\n    <div class="vjs-survey-entry__block">\n      <div class="vjs-survey-entry__choice">\n        <input onchange="handleAnswer(' + marker.order + ')" type="radio" id="choice_1"value="1" ' + setCheckedValue(marker, '1') + '  name="resp"/>\n        <label for="choice_1"></label>\n        <span>' + player.localize('Yes') + '</span>\n      </div>\n      <div class="vjs-survey-entry__choice">\n        <input onchange="handleAnswer(' + marker.order + ')" type="radio" id="choice_2" value="0" ' + setCheckedValue(marker, '0') + ' name="resp"/>\n        <label for="choice_2"></label>\n        <span>' + player.localize('No') + '</span>\n      </div>' + nsp + ('</div>\n    <div class="vjs-survey-entry__redirect"></div>\n    <div class="vjs-survey-entry__action">\n        <button class="cancel" onclick="cancel()" type="button">Ignorer</button>\n        <button class="submit" onclick="submit(' + marker.order + ')" type="button">Valider</button>\n    </div>');
  return content;
}

function chapterContent(marker) {
  var content = '<h1 class="vjs-survey-entry__question">' + marker.title + '</h1>\n    <div class="vjs-survey-entry__action">\n        <button class="submit" onclick="submit(' + marker.order + ')" type="button">Valider</button>\n    </div>\n    ';
  return content;
}

function quizContent(marker) {
  var type = marker.nsp ? 'radio' : 'checkbox';
  var choices = '';
  var choice = '';
  for (var i = 0; i < marker.choices.length; i++) {
    choice = '<div class="vjs-survey-entry__choice">\n    <input type="' + type + '" id="' + marker.choices[i].id + '" ' + setCheckedValue(marker, marker.choices[i].id + '') + '  value="' + marker.choices[i].id + '" name="' + marker.id + '"/>\n    <label for="' + marker.choices[i].id + '"></label>\n        <span>' + marker.choices[i].choice + '</span>\n    </div>';
    choices = choices + choice;
    choice = '';
  }
  var content = '<h1 class="vjs-survey-entry__question">' + marker.title + '</h1>\n    <div class="vjs-survey-entry__block">' + choices + ('</div>\n    <div class="vjs-survey-entry__action">\n        <button class="cancel" onclick="cancel()" type="button">Ignorer</button>\n        <button class="submit" onclick="submit(' + marker.order + ')" type="button">Valider</button>\n    </div>');
  return content;
}

function questionContentI2(marker) {
  var nsp = '';
  if (marker.nsp) {
    nsp = '<div class="vjs-survey-entry__choice">\n    <input type="radio" id="choice_3" value="2" ' + setCheckedValue(marker, '2') + ' name="resp"/>\n    <label for="choice_3">' + player.localize('Nsp') + '</label>\n    </div>';
  }
  var content = '<h1 class="vjs-survey-entry__question">' + marker.title + '</h1>\n    <div class="vjs-survey-entry__block dark-buttons">\n    <div class="vjs-survey-entry__choice dark-buttons">\n    <input onchange="handleAnswer(' + marker.order + ')" type="radio" id="choice_1"value="1" ' + setCheckedValue(marker, '1') + '  name="resp"/>\n    <label for="choice_1">' + player.localize('Yes') + '</label>\n    </div>\n    <div class="vjs-survey-entry__choice dark-buttons">\n    <input onchange="handleAnswer(' + marker.order + ')" type="radio" id="choice_2" value="0" ' + setCheckedValue(marker, '0') + ' name="resp"/>\n    <label for="choice_2">' + player.localize('No') + '</label>\n    </div>' + nsp + ('</div>\n    <div class="vjs-survey-entry__redirect"></div>\n    <div class="vjs-survey-entry__action">\n    <button class="cancel" onclick="cancel()" type="button">Ignorer</button>\n      <button class="submit" onclick="submit(' + marker.order + ')" type="button">Valider</button>\n    </div>');
  return content;
}

function hiddenAreaContentI2(marker) {
  var nsp = '';
  if (marker.nsp) {
    nsp = '<div class="vjs-survey-entry__choice">\n    <input type="radio" id="choice_3" value="2" ' + setCheckedValue(marker, '2') + ' name="resp"/>\n    <label for="choice_3">' + player.localize('Nsp') + '</label>\n    </div>';
  }
  var content = '<h1 class="vjs-survey-entry__question">' + marker.title + '</h1>\n    <div class="vjs-survey-entry__block">\n    <div class="vjs-survey-entry__choice">\n    <input type="radio" id="choice_1"value="1" ' + setCheckedValue(marker, '1') + '  name="resp"/>\n    <label for="choice_1">' + player.localize('Yes') + '</label>\n    </div>\n    <div class="vjs-survey-entry__choice">\n    <input type="radio" id="choice_2" value="0" ' + setCheckedValue(marker, '0') + ' name="resp"/>\n    <label for="choice_2">' + player.localize('No') + '</label>\n    </div>' + nsp + ('</div>\n    <div class="vjs-survey-entry__action">\n        <button class="cancel" onclick="cancel()" type="button">Annuler</button>\n        <button class="submit" onclick="submit(' + marker.order + ')" type="button">Valider</button>\n    </div>');
  return content;
}

function chapterContentI2(marker) {
  var content = '<h1 class="vjs-survey-entry__question">' + marker.title + '</h1>\n    <div class="vjs-survey-entry__action">\n        <button class="submit" onclick="submit(' + marker.order + ')" type="button">Valider</button>\n    </div>\n    ';
  return content;
}

function quizContentI2(marker) {
  var type = !marker.nsp ? 'radio' : 'checkbox';
  var choices = '';
  var choice = '';
  for (var i = 0; i < marker.choices.length; i++) {
    choice = '<div class="vjs-survey-entry__choice">\n    <input onchange="handleAnswer(' + marker.order + ')" type="' + type + '" id="' + marker.choices[i].id + '" ' + setCheckedValue(marker, marker.choices[i].id + '') + '  value="' + marker.choices[i].id + '" name="' + marker.id + '"/>\n    <label for="' + marker.choices[i].id + '">' + marker.choices[i].choice + '</label>\n    </div>';
    choices = choices + choice;
    choice = '';
  }
  var content = '<h1 class="vjs-survey-entry__question">' + marker.title + '</h1>\n    <div class="vjs-survey-entry__block">' + choices + ('</div>\n    <div class="vjs-survey-entry__redirect"></div>\n    <div class="vjs-survey-entry__action">\n        <button class="cancel" onclick="cancel()" type="button">Ignorer</button>\n        <button class="submit" onclick="submit(' + marker.order + ')" type="button">Valider</button>\n    </div>');
  return content;
}

function getElementBounding(element) {
  var elementBounding;
  var defaultBoundingRect = {
    top: 0,
    bottom: 0,
    left: 0,
    width: 0,
    height: 0,
    right: 0
  };
  try {
    elementBounding = element.getBoundingClientRect();
  } catch (e) {
    elementBounding = defaultBoundingRect;
  }
  return elementBounding;
}

function initializeMarkerTip() {
  markerTip = dom.createEl('div', {
    className: 'vjs-tip',
    innerHTML: "<div class='vjs-tip-arrow'></div>"
  });
}

// create a non-colliding random number
function generateUUID() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}

function setMarkderDivStyle(marker, markerDiv) {
  markerDiv.className = 'vjs-skin-control-bar ' + (marker.type || '');
  var wrapper = document.createElement('div');
  wrapper.className = 'marker-content';
  if (marker.type === 'question') {
    wrapper.innerHTML = svg_survey + svg_indicator;
  } else if (marker.type === 'comment') {
    wrapper.innerHTML = svg_comment + svg_indicator;
  } else if (marker.type === 'quiz') {
    wrapper.innerHTML = svg_like + svg_indicator;
  } else if (marker.type === 'sondage') {
    wrapper.innerHTML = svg_sondage + svg_indicator;
  } else if (marker.type === 'chapter') {
    wrapper.innerHTML = svg_chapters + svg_indicator;
  }
  markerDiv.appendChild(wrapper);
  Object.keys(setting.markerStyle).forEach(function (key) {
    markerDiv.style[key] = setting.markerStyle[key];
  });
  // hide out-of-bound markers
  var ratio = marker.start / player.duration();
  if (ratio < 0 || ratio > 1) {
    markerDiv.style.display = 'none';
  }
  // set position
  markerDiv.style.right = 100 - getPosition(marker) + '%';
  if (marker.duration) {
    markerDiv.style.width = marker.duration / player.duration() * 100 + '%';
    markerDiv.style.marginRight = '0px';
  } else {
    var markerDivBounding = getElementBounding(markerDiv);
    var width_marker = markerDivBounding.width && markerDivBounding.width > 0 ? markerDivBounding.width : 0;
    markerDiv.style.marginRight = width_marker / 2 + 'px';
  }
}

function getPosition(marker) {
  return setting.markerTip.time(marker) / player.duration() * 100;
}

var order = 0;

function createMarkerDiv(marker) {
  var markerDiv = dom.createEl('div', {}, {
    'data-marker-key': marker.key,
    'data-marker-time': marker.start
  });
  marker.div = markerDiv;
  marker.order = order;
  marker.answered = [];
  order++;
  setMarkderDivStyle(marker, markerDiv);
  // bind click event to seek to marker time
  if (markerDiv.addEventListener) {
    markerDiv.addEventListener('click', function (e) {
      var key = this.getAttribute('data-marker-key');
      var markerTip = setting.markerTip.time(markersMap[key]);
      if (player.currentTime() >= markerTip - 2 && player.currentTime() <= markerTip + 2) {
        var preventDefault = false;
        if (typeof setting.onMarkerClick === 'function') {
          // if return false, prevent default behavior
          preventDefault = setting.onMarkerClick(marker) === false;
        }
        if (!preventDefault) {
          player.currentTime(setting.markerTip.time(markersMap[key]));
        }
      }
    });
  } else {
    markerDiv.attachEvent('onclick', function (e) {
      var key = this.getAttribute('data-marker-key');
      if (player.currentTime() == setting.markerTip.time(markersMap[key])) {
        var preventDefault = false;
        if (typeof setting.onMarkerClick === 'function') {
          // if return false, prevent default behavior
          preventDefault = setting.onMarkerClick(marker) === false;
        }
        if (!preventDefault) {
          player.currentTime(setting.markerTip.time(markersMap[key]));
        }
      }
    });
  }
  if (setting.markerTip.display) {
    
  }
  return markerDiv;
}

function addMarkers(newMarkers) {
  newMarkers.forEach(function (marker) {
    if (!options.currentSkin.indexOf('skin-i2') > -1 && marker.type === 'hidden-area') {
      order++;
      return;
    }
    marker.key = generateUUID();
    player.el().querySelector('.vjs-progress-holder').appendChild(createMarkerDiv(marker));
    // store marker in an internal hash map
    markersMap[marker.key] = marker;
    markersList.push(marker);
  });
  sortMarkersList();
  if (options.currentSkin.indexOf('skin-dark') > -1) {
    newMarkers.forEach(function (marker) {
      var markerDiv = docShadow.querySelector('[data-marker-key="' + marker.key + '"]');
      if (!markerDiv) {
        return;
      }
      var markerDivStyle = window.getComputedStyle(markerDiv);
      // Q test to avoid having width: auto.
      var width = markerDivStyle.width !== 'auto' ? markerDivStyle.width : '60px';
      var rightStyle = 'calc(' + markerDiv.style.right + ' - ' + width + ' / 2)';
      markerDiv.style.right = rightStyle;
    });
  }
}

function openModal(options) {
  player.getChild('ControlTopOverlay').open(options);
}

function onTimeUpdate() {
  onUpdateMarker();
  updateBreakOverlay();
  options.onTimeUpdateAfterMarkerUpdate && options.onTimeUpdateAfterMarkerUpdate();
}

function initialize() {
  if (setting.markerTip.display) {
    initializeMarkerTip();
  }
  // remove existing markers if already initialized
  player.skinControlBar.removeAll();
  addMarkers(setting.markers);
  if (setting.breakOverlay.display) {
    initializeOverlay();
  }
  //createControlTop();
  if (document.addEventListener) {
    document.addEventListener('click', function (e) {
      if (e.target && e.target.id === 'control-button-share') {
        breakOverlay.style.visibility = 'hidden';
        var index = e.target.getAttribute('data-index');
        player.getChild('ControlTopOverlay').open(controlTopOptions[parseInt(index)]);
      }
    });
  } else {
    document.attachEvent('onclick', function (e) {
      if (e.target && e.target.id === 'control-button-share') {
        breakOverlay.style.visibility = 'hidden';
        var index = e.target.getAttribute('data-index');
        player.getChild('ControlTopOverlay').open(controlTopOptions[parseInt(index)]);
      }
    });
  }

  onTimeUpdate();
  player.on('timeupdate', onTimeUpdate);
  player.off('loadedmetadata');
}

function onUpdateMarker() {
  /*
   check marker reached in between markers
   the logic here is that it triggers a new marker reached event only if the player
   enters a new marker range (e.g. from marker 1 to marker 2). Thus, if player is on marker 1 and user clicked on marker 1 again, no new reached event is triggered)
   */
  if (!markersList.length) {
    return;
  }

  var getNextMarkerTime = function getNextMarkerTime(index) {
    if (index < markersList.length - 1) {
      return setting.markerTip.time(markersList[index + 1]);
    }
    // next marker time of last marker would be end of video time
    return player.duration();
  };
  var currentTime = player.currentTime();
  var newMarkerIndex = NULL_INDEX;

  if (currentMarkerIndex !== NULL_INDEX) {
    // check if staying at same marker
    var nextMarkerTime = getNextMarkerTime(currentMarkerIndex);
    if (currentTime >= setting.markerTip.time(markersList[currentMarkerIndex]) && currentTime < nextMarkerTime) {
      return;
    }

    // check for ending (at the end current time equals player duration)
    if (currentMarkerIndex === markersList.length - 1 && currentTime === player.duration()) {
      return;
    }
  }
  // check first marker, no marker is selected
  if (currentTime <= setting.markerTip.time(markersList[0])) {
    newMarkerIndex = NULL_INDEX;
  } else {
    // look for new index
    for (var i = 0; i < markersList.length; i++) {
      nextMarkerTime = getNextMarkerTime(i);
      if (currentTime >= setting.markerTip.time(markersList[i]) && currentTime < nextMarkerTime) {
        newMarkerIndex = i;
        break;
      }
    }
  }
  // set new marker index
  if (newMarkerIndex !== currentMarkerIndex) {
    // trigger event if index is not null
    if (newMarkerIndex !== NULL_INDEX && options.onMarkerReached && markersList[newMarkerIndex].type !== "hidden-area") {
      player.pause();
      options.onMarkerReached(markersList[newMarkerIndex], newMarkerIndex);
    }
    currentMarkerIndex = newMarkerIndex;
  }
}

function updateBreakOverlay() {
  if (!setting.breakOverlay.display || currentMarkerIndex < 0) {
    return;
  }

  var currentTime = Math.floor(player.currentTime());
  var marker = markersList[currentMarkerIndex];
  var markerTime = setting.markerTip.time(marker);
  if (currentTime >= markerTime && currentTime <= markerTime + setting.breakOverlay.displayTime) {
    if (overlayIndex !== currentMarkerIndex) {
      overlayIndex = currentMarkerIndex;
      if (breakOverlay && marker.type !== 'hidden-area') {
        breakOverlay.querySelector('.vjs-break-overlay-text').innerHTML = setting.breakOverlay.text(marker);
      }
    }

    if (breakOverlay && marker.type !== 'hidden-area') {
      breakOverlay.style.visibility = "visible";
    } else {
      if (breakOverlay) {
        breakOverlay.style.visibility = "hidden";
      }
    }
  } else {
    overlayIndex = NULL_INDEX;
    if (breakOverlay) {
      breakOverlay.style.visibility = 'hidden';
    }
  }
}

function removeMarkers(indexArray) {
  // reset overlay
  if (!!breakOverlay) {
    overlayIndex = NULL_INDEX;
    breakOverlay.style.visibility = 'hidden';
  }
  currentMarkerIndex = NULL_INDEX;

  var deleteIndexList = [];
  indexArray.forEach(function (index) {
    var marker = markersList[index];
    if (marker) {
      // delete from memory
      delete markersMap[marker.key];
      deleteIndexList.push(index);

      // delete from dom
      var el = player.el().querySelector(".vjs-marker[data-marker-key='" + marker.key + "']");
      el && el.parentNode.removeChild(el);
    }
  });

  // clean up markers array
  deleteIndexList.reverse();
  deleteIndexList.forEach(function (deleteIndex) {
    markersList.splice(deleteIndex, 1);
  });

  // sort again
  sortMarkersList();
}

function sortMarkersList() {
  // sort the list by time in asc order
  markersList.sort(function (a, b) {
    return setting.markerTip.time(a) - setting.markerTip.time(b);
  });
}

// problem when the next marker is within the overlay display time from the previous marker
function initializeOverlay() {
  breakOverlay = dom.createEl('div', {
    className: 'vjs-break-overlay',
    innerHTML: "<div class='vjs-break-overlay-text'></div>"
  });

  Object.keys(setting.breakOverlay.style).forEach(function (key) {
    if (breakOverlay) {
      breakOverlay.style[key] = setting.breakOverlay.style[key];
    }
  });

  player.el().appendChild(breakOverlay);
  overlayIndex = NULL_INDEX;
}

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function skinControlBar
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var skinControlBar = function skinControlBar(options) {
  var _this = this;

  this.ready(function () {
    player = _this;
    player.skinControlBar = {
      getMarkers: function getMarkers() {
        return markersList;
      },
      next: function next() {
        // go to the next marker from current timestamp
        var currentTime = player.currentTime();
        for (var i = 0; i < markersList.length; i++) {
          var markerTime = setting.markerTip.time(markersList[i]);
          if (markerTime > currentTime) {
            player.currentTime(markerTime);
            break;
          }
        }
      },
      prev: function prev() {
        // go to previous marker
        var currentTime = player.currentTime();
        for (var i = markersList.length - 1; i >= 0; i--) {
          var markerTime = setting.markerTip.time(markersList[i]);
          // add a threshold
          if (markerTime + 0.5 < currentTime) {
            player.currentTime(markerTime);
            return;
          }
        }
      },
      add: function add(newMarkers) {
        // add new markers given an array of index
        addMarkers(newMarkers);
      },
      remove: function remove(indexArray) {
        // remove markers given an array of index
        removeMarkers(indexArray);
      },
      removeAll: function removeAll() {
        var indexArray = [];
        for (var i = 0; i < markersList.length; i++) {
          indexArray.push(i);
        }
        removeMarkers(indexArray);
      },
      // force - force all markers to be updated, regardless of if they have changed or not.
      updateTime: function updateTime(force) {
        // notify the plugin to update the UI for changes in marker times
        updateMarkers(force);
      },
      reset: function reset(newMarkers) {
        // remove all the existing markers and add new ones
        player.skinControlBar.removeAll();
        addMarkers(newMarkers);
      },
      destroy: function destroy() {
        // unregister the plugins and clean up even handlers
        player.skinControlBar.removeAll();
        breakOverlay && breakOverlay.remove();
        markerTip && markerTip.remove();
        player.off('timeupdate', updateBreakOverlay);
        delete player.skinControlBar;
      }
    };
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
    // exposed plugin API
  });
};

// Register the plugin with video.js.

videojs.registerComponent('ControlTopOverlay', ControlTopOverlay);
videojs.registerComponent('ControlTopButton', ControlTopButton);
videojs.registerComponent('ControlTopModal', ControlTopModal);
videojs.registerComponent('ModalContent', ModalContent);

registerPlugin('skinControlBar', skinControlBar);

// Include the version number.
skinControlBar.VERSION = version;

module.exports = skinControlBar;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_skin_control_bar/dist/videojs-skin-control-bar.cjs.js
// module id = 537
// module chunks = 39